import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "bsp-page-header" }
const _hoisted_2 = { class: "bsp-page-header__content" }
const _hoisted_3 = { class: "bsp-page-header__copy" }
const _hoisted_4 = {
  key: 0,
  class: "bsp-page-header__eyebrow"
}
const _hoisted_5 = { class: "bsp-page-header__title-row" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 2,
  class: "bsp-page-header__meta"
}

import { AHeader, AIcon, ATag, type ATagColor } from '@adereso-ai/vue-components'
import type { PropType } from 'vue'

interface BspBreadcrumb {
  title: string
  disabled?: boolean
  icon?: string
  to?: {
    name?: string
    path?: string
    query?: Record<string, string | number>
    params?: Record<string, string | number>
  }
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BspPageHeader',
  props: {
  title: {
    type: String,
    required: true
  },
  description: {
    type: String,
    default: ''
  },
  eyebrow: {
    type: String,
    default: ''
  },
  icon: {
    type: String,
    default: ''
  },
  status: {
    type: String,
    default: ''
  },
  statusColor: {
    type: String as PropType<ATagColor>,
    default: 'info'
  },
  breadcrumbs: {
    type: Array as PropType<BspBreadcrumb[]>,
    default: () => []
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_unref(AHeader), {
      "breadcrumbs-items": __props.breadcrumbs,
      "help-button": false
    }, {
      "custom-buttons": _withCtx(() => [
        _renderSlot(_ctx.$slots, "actions")
      ]),
      _: 3
    }, 8, ["breadcrumbs-items"]),
    _createElementVNode("div", _hoisted_2, [
      (__props.icon)
        ? (_openBlock(), _createBlock(_unref(AIcon), {
            key: 0,
            icon: __props.icon,
            color: "primary",
            size: "28",
            "with-container": ""
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (__props.eyebrow)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.eyebrow), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h1", null, _toDisplayString(__props.title), 1),
          (__props.status)
            ? (_openBlock(), _createBlock(_unref(ATag), {
                key: 0,
                text: __props.status,
                color: __props.statusColor,
                type: "secondary"
              }, null, 8, ["text", "color"]))
            : _createCommentVNode("", true)
        ]),
        (__props.description)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(__props.description), 1))
          : _createCommentVNode("", true),
        (_ctx.$slots.meta)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _renderSlot(_ctx.$slots, "meta")
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})